const BASE_URL = 'https://api.cc.andreyonweb.ru'

export default {
  token_login: BASE_URL+'/users/signup/get_token',
  set_profile: BASE_URL+'/users/signup/set_profile',
  users: BASE_URL+'/users/api',
  request: BASE_URL+'/request/api',
  request_upload_csv: BASE_URL+'/request/upload/csv',
  content:  BASE_URL+'/content/api',
  av100: BASE_URL+'/av100/sender/get',
  crd: BASE_URL+'/crd/api',
  crd_report: BASE_URL+'/crd/api/get_report',
  crd_report_all: BASE_URL+'/crd/api/get_report_all',
  crd_report_user: BASE_URL+'/crd/api/get_report_user',
}
